import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { IonLabel, IonThumbnail, IonList, IonItem, IonSkeletonText } from '@ionic/react';

type Props = RouteComponentProps<{}> & {
  loading: boolean;
}

class SkeletonLoading extends Component<Props> {
  // constructor(props: Props) {
  //   super(props);
  // }
  render() {
    return (
    <div id="skeleton">
      <div className={this.props.loading ? '' : 'hidden'}>
        <IonList class="loading">
          <IonItem>
            <IonThumbnail slot="start">
              <IonSkeletonText class="loading"></IonSkeletonText>
            </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel class="loading">
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonThumbnail slot="start">
                <IonSkeletonText class="loading"></IonSkeletonText>
              </IonThumbnail>
            <IonLabel>
              <IonSkeletonText class="loading" animated style={{ width: '100%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '90%' }}></IonSkeletonText>
              <IonSkeletonText class="loading" animated style={{ width: '80%' }}></IonSkeletonText>
            </IonLabel>
          </IonItem>
        </IonList>
      </div>
    </div>
    );
  }
};

export default withRouter(SkeletonLoading);
